import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  FormGroup,
  FormControlLabel,
  Tooltip,
  Menu,
  MenuItem,
  IconButton,
  Button,
  Link,
} from "@material-ui/core";
import OpenSnackbar from "../../../Shared/OpenSnackbar";
import { AccountCircle, Brightness4, Brightness7 } from "@material-ui/icons";
import { ThemeContext } from "../../../Context/Theme";
import { AuthContext } from "../../../Context/Auth";
import { Auth } from "aws-amplify";

import { makeStyles } from "@material-ui/styles";
import SwitchComp from "../SwitchComponent";
import { withRouter } from "react-router";
import { RouteContext } from "../../../Context/RouteContext";
import { useErrorHandler } from "react-error-boundary";
import modalStyles from "./styles.module.css";
import { Instance } from "../../../Context/axiosContext";
import Modal from "react-modal";
import { RestaurantContext } from "../../../Context/RestaurantData";
import LockSettingButton from "../LockSettingButton";

const useStyles = makeStyles({
  linkStyle: {
    textDecoration: "none",
    color: "black",
  },
  linkStyleDark: {
    textDecoration: "none",
    color: "White",
  },
  smallLink: {
    fontSize: "10px",
    cursor: "pointer",
  },
  modalDiv: {
    display: "flex",
    flexDirection: "column",
  },
  modalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
});
const DesktopView = ({
  classes,
  switchValue,
  setSwitchValue,
  handleSwitch,
  history,
}) => {
  const { dark, toggle } = useContext(ThemeContext);
  const { setRestaurantData, restaurantData } = useContext(RestaurantContext);
  const { logout, user } = useContext(AuthContext);
  const { resetRoute } = useContext(RouteContext);
  const axiosInstance = Instance();
  const [anchorEl, setAnchorEl] = useState(null);
  const [restStatus, setRestStatus] = useState();
  const styles = useStyles();
  const [restData, setRestData] = useState([]);
  const [Slug, setSlug] = useState("");
  const errorHandler = useErrorHandler();
  const [apiKey, setApiKey] = useState("");
  let mode = localStorage.getItem("mode");
  const [isOpen, setIsOpen] = useState(false);
  // const [lockStatus, setLockStatus] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function signOut() {
    Auth.signOut()
      .then((data) => {
        logout();
        localStorage.clear();
        resetRoute();
      })
      .catch((err) => {});
  }

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const getRestStatus = async () => {
    try {
      const { data } = await axiosInstance.get(
        process.env.REACT_APP_API_URL + `restaurant`,
        {
          headers: {
            Authorization: user,
            ["x-api-key"]: apiKey || localStorage.getItem("apikey"),
          },
        }
      );
      if (data) {
        setRestStatus(data.restaurant_open);
        setSwitchValue(data.restaurant_open);
        setRestaurantData(data);
        setSlug(data.slug);
        // setLockStatus(data.lock_setting);
        localStorage.setItem("rest_name", data.name);
      }
    } catch (err) {}
  };

  const endSession = () => {
    logout();
    localStorage.clear();
  };

  const handleChange = (name, index) => {
    setApiKey(restData[index].api_key);
    localStorage.setItem("apikey", restData[index].api_key);
    window.location.reload();
    toggleModal();
  };

  const changeRestStatus = async () => {
    if (restStatus) {
      axiosInstance
        .get(process.env.REACT_APP_API_URL + `restaurant/test-id/close`, {
          headers: {
            Authorization: user,
            ["x-api-key"]: apiKey,
          },
        })
        .then((data) => {
          getRestStatus();
          handleSwitch();
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.error === "Unauthorized") {
            handleSnackbarOpen(
              "Please disable settings lock to make changes..😥",
              "errorDark"
            );
            return;
          }
        });
    } else {
      axiosInstance
        .get(process.env.REACT_APP_API_URL + `restaurant/test-id/open`, {
          headers: {
            Authorization: user,
            ["x-api-key"]: apiKey,
          },
        })
        .then((data) => {
          getRestStatus();
          handleSwitch();
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.error === "Unauthorized") {
            handleSnackbarOpen(
              "Please disable settings lock to make changes..😥",
              "errorDark"
            );
            return;
          }
        });
    }
  };

  useEffect(() => {
    setRestData(JSON.parse(localStorage.getItem("restaurants")));
  }, []);

  useEffect(() => {
    setApiKey(restaurantData?.api_key);
    setSlug(restaurantData?.slug);
  }, [restaurantData]);

  return (
    <>
      {mode === "superadmin" && (
        <Button color="secondary" variant="outlined" onClick={endSession}>
          End Superadmin Session
        </Button>
      )}
      {restaurantData.lock_setting !== undefined && (
        <>
          <Typography
            className={classes.ml20}
            variant="subtitle1"
            color="primary"
          >
            Setting Lock
          </Typography>
          <FormGroup className={classes.ml20}>
            <FormControlLabel
              control={
                <LockSettingButton
                  status={restaurantData.lock_setting}
                  getRestStatus={getRestStatus}
                />
              }
              label={
                restaurantData.lock_setting ? (
                  <Typography color="primary"> Locked </Typography>
                ) : (
                  <Typography color="primary"> Unlocked </Typography>
                )
              }
            />
          </FormGroup>
        </>
      )}
      <Typography className={classes.ml20} variant="subtitle1" color="primary">
        Store
      </Typography>
      <FormGroup onClick={changeRestStatus} className={classes.ml20}>
        <FormControlLabel
          control={
            <SwitchComp
              data-testid="desktopSwitch"
              checked={switchValue}
              onChange={handleSwitch}
              name="switchValue"
              disabled={restaurantData.lock_setting}
            />
          }
          label={
            switchValue ? (
              <Typography color="primary"> OPENED </Typography>
            ) : (
              <Typography color="primary"> CLOSED </Typography>
            )
          }
        />
      </FormGroup>

      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        className={modalStyles.mymodal}
        overlayClassName={modalStyles.myoverlay}
        closeTimeoutMS={50}
      >
        <div className={styles.modalDiv}>
          {restData?.map((item, index) => (
            <div className={styles.modalRow} key={index}>
              <Typography color="primary"> {item?.name} </Typography>
              <Button
                className={styles.btnStyle}
                onClick={() => handleChange(item.name, index)}
                variant="contained"
                color="secondary"
                size="small"
              >
                Login
              </Button>
            </div>
          ))}
        </div>
      </Modal>

      <Typography className={classes.ml20} variant="subtitle1" color="primary">
        <a
          className={dark ? styles.linkStyleDark : styles.linkStyle}
          target="blank"
          href={`${process.env.REACT_APP_STAGE}/${Slug}`}
        >
          {restaurantData?.name || ""}
        </a>
        {localStorage.getItem("isMultiOwner") === "true" && (
          <Link className={styles.smallLink} onClick={toggleModal}>
            {" "}
            Change?
          </Link>
        )}
      </Typography>

      <Tooltip title={dark ? "Toggle light mode" : "Toggle dark mode"} arrow>
        <IconButton
          onClick={toggle}
          className={classes.ml20}
          disableRipple
          disableTouchRipple
        >
          {!dark ? (
            <Brightness4 className={classes.accountIconStyles} />
          ) : (
            <Brightness7 className={classes.accountIconStyles} />
          )}
        </IconButton>
      </Tooltip>

      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={classes.ml20}
        disableRipple
        disableTouchRipple
      >
        <AccountCircle className={classes.accountIconStyles} />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => history.push("/reset-password")}>
          Reset Password
        </MenuItem>
        <MenuItem onClick={signOut}>Logout</MenuItem>
      </Menu>
      {snackbarOpen && (
        <OpenSnackbar
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          open={snackbarOpen}
          setOpen={setSnackbarOpen}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </>
  );
};

export default withRouter(DesktopView);
